module.exports = __webpack_public_path__ + "static/img/nars-bg.e6bc474.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nars-bg.jpg
// module id = LrfV
// module chunks = 0